import { DateInput } from "react-aria-components";

import styled from "@emotion/styled";

export const StyledDateInput = styled(DateInput)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: ${({ theme }) => theme.fontSizes["paragraph-s"]};
  color: ${({ theme }) => theme.colors.text.primary};

  width: fit-content;
  min-width: 50px;
  white-space: nowrap;
  forced-color-adjust: none;
`;
